import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { SystemOverviewDto } from '../types';

export const getSystemOverview = async (): Promise<SystemOverviewDto> => {
  const { data }: { data: SystemOverviewDto } = await axios.get(
    `/api/system-overview`
  );
  return data as SystemOverviewDto;
};

type QueryFnType = typeof getSystemOverview;

type UseSystemOverviewOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSystemOverview = ({ config }: UseSystemOverviewOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['systemOverview'],
    queryFn: () => getSystemOverview(),
    ...config,
  });
};
